import { Link } from "@remix-run/react"
import { Button } from "./ui/button"

interface Props {
	imagePath: string
	title: string
	text: string
	tag?: string
	tagHref: string
	ctaText: string
	ctaHref: string
}

export default function HeroSplit({
	imagePath,
	title,
	text,
	tag,
	tagHref,
	ctaText,
	ctaHref,
}: Props) {
	if (!imagePath) {
		return null
	}
	return (
		<div className="relative overflow-hidden bg-primary lg:rounded-xl">
			<style>
				{`
.lg-grid-reverse {
	grid-template-areas: 
			"area2"
			"area1";
}
				`}
			</style>
			<div className="lg-grid-reverse mx-auto max-w-7xl lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8">
				<div className="lg:grid-area:area1 px-6 pb-24 pt-10 sm:pb-32 lg:col-span-7 lg:px-0 lg:pb-56 lg:pt-48 xl:col-span-6">
					<div className="mx-auto max-w-2xl lg:mx-0">
						<div className="hidden sm:mt-32 sm:flex lg:mt-16">
							{tag && (
								<div className="hover:ring-primary-foreground-900/20 relative rounded-full px-3 py-1 text-sm text-primary-foreground ring-1 ring-primary-foreground/10">
									{tag}
									{"  "}
									<Link
										to={tagHref}
										className="ml-2 cursor-pointer whitespace-nowrap font-medium underline"
									>
										<span className="absolute inset-0" aria-hidden="true" />
										Read more <span aria-hidden="true">&rarr;</span>
									</Link>
								</div>
							)}
						</div>
						<h1 className="mt-24 text-4xl font-bold tracking-tight text-primary-foreground sm:mt-10 sm:text-5xl">
							{title}
						</h1>
						<p className="mt-6 text-lg leading-8 text-primary-foreground">
							{text}
						</p>
						<div className="mt-10 flex items-center gap-x-6">
							<Button variant="default">
								<Link to={ctaHref}>{ctaText}</Link>
							</Button>
						</div>
					</div>
				</div>
				<div className="lg:grid-area:area2 relative lg:col-span-5 lg:-mr-8 xl:absolute xl:inset-0 xl:left-1/2 xl:mr-0">
					<img
						className="lg:aspect-auto aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:h-full"
						src={imagePath}
						alt=""
					/>
				</div>
			</div>
		</div>
	)
}
